import React from "react";
import TailoredRestaurants from "../../assets/tailored_for_restaurants.webp";
import FastFood from "../../assets/fast_food_chains.webp";
import OfflineStores from "../../assets/offline_stores.webp";
import Large from "../../assets/large_online_offline_businesses.webp";

const FourCards = () => {
  const cards = [
    {
      title: "Retail Stores & General Shops",
      text: "Send goods to customers or restock branches quickly without owning a fleet.",
      image: TailoredRestaurants,
      bg: "bg-[#eaf4fb]",
      border: "border-[#9fd4ff]",
    },
    {
      title: "Distributors & Wholesalers",
      text: "Deliver bulk shipments to retailers with real-time tracking and reliability.",
      image: FastFood,
      bg: "bg-[#e8fbf6]",
      border: "border-[#a8eedf]",
    },
    {
      title: "E-commerce Sellers",
      text: "Manage customer deliveries and returns directly from your warehouse.",
      image: OfflineStores,
      bg: "bg-[#f7f1df]",
      border: "border-[#efd58f]",
    },
    {
      title: "Large & Multi-Location Businesses",
      text: "Streamline deliveries across multiple stores, franchises, or corporate clients.",
      image: Large,
      bg: "bg-[#f3e8fb]",
      border: "border-[#d19cf7]",
    },
  ];

  return (
    <section className="px-4 py-10 md:py-14">
      <div className="mx-auto max-w-[1200px]">
     <h2 className="text-center font-bold text-[#212529] text-[24px] leading-7 sm:text-[24px] md:text-[28px] lg:text-[28px] font-sf">
  Businesses That Can Benefit from Packky
</h2>

        <p className="mt-4 text-center text-[18px] md:text-[20px] text-[#212529] font-sf">
          Smart Deliveries, Satisfied Customers
        </p>

        <div className="mt-10 max-w-[1600px] grid grid-cols-1 gap-5 md:grid-cols-2">
          {cards.map((item, index) => (
            <div
              key={index}
              className={`rounded-[18px] border p-4 md:p-5 ${item.bg} ${item.border}`}
            >
              <div className="flex h-full flex-col">
                <div className="min-h-[100px] md:min-h-[110px]">
                  <h3 className="text-left text-[20px] font-bold leading-snug text-[#1f2937]">
                    {item.title}
                  </h3>

                  <p className="mt-6 max-w-[92%] font-sf text-left text-[16px] leading-7 text-[#667085]">
                    {item.text}
                  </p>
                </div>

                <div className="mt-4 overflow-hidden rounded-[14px] bg-[#f8f8f8]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-[180px] w-full object-cover md:h-[170px] lg:h-[240px]"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FourCards;